/*
 * Levels Beyond CONFIDENTIAL
 *
 * Copyright 2003 - 2020 Levels Beyond Incorporated
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains the
 * property of Levels Beyond Incorporated and its suppliers, if
 * any. The intellectual and technical concepts contained herein
 * are proprietary to Levels Beyond Incorporated and its suppliers
 * and may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this
 * material is unlawful and strictly forbidden unless prior
 * written permission is obtained from Levels Beyond Incorporated.
 */

'use strict';

function nielsenTemplatesSearchViewController(this: JS5Object, _: JS5Object, $location: JS5Object,
                                                 uiGridConstants: JS5Object, ModalService: JS5Object,
                                                 NavbarUtilService: JS5Object, $timeout: JS5Function,
                                                 PartnerEditService: JS5Object, NotificationService: JS5Object): void {
    this.showHidden = false;

    const getData = () => {
        this.loadingIndicator.show = true;
        PartnerEditService.getNielsenTemplatesForPartner(this.partnerObject.id, this.showHidden)
            .then((nielsenTemplates: JS5Object) => {
                this.gridOptions.data = nielsenTemplates;
                this.searchText = _.get($location.search(), 'searchText') || null;
                filterGrid(this.searchText);
            }).finally(() => {
                this.loadingIndicator.show = false;
            });
    };
    const navigateTonielsenTemplatesEditViewFromDoubleClick = (row: JS5Object): void => {
        if (!_.get(row, 'hidden')) {
            $location.url(`/system/partners/edit/${this.partnerObject.id}/nielsenTemplates/edit/${row.id}`)
        }
    };
    const navigateToCreateView = () => {
        $location.url(`/system/partners/edit/${this.partnerObject.id}/nielsenTemplates/edit/-1`)
    };
    const navigateToEditViewFromEditButton = () => {
        $location.url(`/system/partners/edit/${this.partnerObject.id}/nielsenTemplates/edit/${_.first(this.gridApi.selection.getSelectedRows()).id}`);
    };
    const cloneItem = () => {
        let nielsenTemplateToClone = _.cloneDeep(_.first(this.gridApi.selection.getSelectedRows()));

        ModalService.showMessageModal({
            messageText: 'Are you sure you want to clone the selected nielsen Template?',
            pullCancelLeft: true,
            title: 'Clone nielsen Template',
            windowClass: 'confirm-modal-sm',
            showOK: true
        }, () => {
            this.loadingIndicator.show = true;
            PartnerEditService.cloneNielsenTemplate(nielsenTemplateToClone.id).then(() => {
                NotificationService.createSuccessNotification('nielsen template successfully cloned!');
                getData();
            }).catch(() => {
                NotificationService.createFailureNotification('Could not clone nielsen template!');
            }).finally(() => {
                this.loadingIndicator.show = false;
            });
        });
    };

    const toggleItemHidden = () => {
        let nielsenTemplateToToggleHidden = _.cloneDeep(_.first(this.gridApi.selection.getSelectedRows()));

        ModalService.showMessageModal({
            messageText: `Are you sure you want to ${nielsenTemplateToToggleHidden.hidden ? 'unhide' : 'hide'} the selected nielsen Template?`,
            pullCancelLeft: true,
            title: `${nielsenTemplateToToggleHidden.hidden ? 'Unhide' : 'Hide'} nielsen Template`,
            windowClass: 'confirm-modal-sm',
            showOK: true
        }, () => {
            this.loadingIndicator.show = true;
            PartnerEditService.toggleNielsenTemplateHidden(nielsenTemplateToToggleHidden.id).then(() => {
                NotificationService.createSuccessNotification(`nielsen template successfully ${nielsenTemplateToToggleHidden.hidden ? 'unhidden' : 'hidden'}!`);
                getData();

            }).catch(() => {
                NotificationService.createFailureNotification(`Could not ${nielsenTemplateToToggleHidden.hidden ? 'unhide' : 'hide'} nielsen template!`);
            }).finally(() => {
                this.loadingIndicator.show = false;
            });
        });
    };

    this.onRowDblClick = (row: JS5Object) => {
        navigateTonielsenTemplatesEditViewFromDoubleClick(row.entity);
    };

    this.toolbarButtonDefs = [
        {
            label: 'New',
            enabled: () => true,
            onClick: navigateToCreateView
        },
        {
            label: 'Edit',
            enabled: () => _.size(this.gridApi.selection.getSelectedRows()) && !_.get(_.first(this.gridApi.selection.getSelectedRows()), 'hidden'),
            onClick: navigateToEditViewFromEditButton
        },
        {
            label: 'Clone',
            enabled: () => _.size(this.gridApi.selection.getSelectedRows()) && !_.get(_.first(this.gridApi.selection.getSelectedRows()), 'hidden'),
            onClick: cloneItem
        },
        {
            label: 'Hide',
            enabled: () => _.size(this.gridApi.selection.getSelectedRows()) &&
                !_.get(_.first(this.gridApi.selection.getSelectedRows()), 'hidden'),
            onClick: toggleItemHidden
        },
        {
            label: 'Unhide',
            enabled: () => _.size(this.gridApi.selection.getSelectedRows()) &&
                _.get(_.first(this.gridApi.selection.getSelectedRows()), 'hidden'),
            onClick: toggleItemHidden
        }
    ];


    let columnDefinitions = [
        {
            field: 'name',
            displayName: 'Name',
            cellTemplate: 'components/visual/grid/padded-base-tooltip-template.html'
        },
        {
            field: 'data.nielsenAssetId',
            displayName: 'Asset ID',
            cellTemplate: 'components/visual/grid/padded-base-tooltip-template.html'
        },
        {
            field: 'data.nielsenAssetName',
            displayName: 'Asset Name',
            cellTemplate: 'components/visual/grid/padded-base-tooltip-template.html'
        },
        {
            field: 'data.nielsenDsrcId',
            displayName: 'DSRC ID',
            cellTemplate: 'components/visual/grid/padded-base-tooltip-template.html'
        },
        {
            field: 'data.nielsenDsrcName',
            displayName: 'DSRC Name',
            cellTemplate: 'components/visual/grid/padded-base-tooltip-template.html'
        },
        {
            field: 'data.nielsenEpisodeId',
            displayName: 'Episode ID',
            cellTemplate: 'components/visual/grid/padded-base-tooltip-template.html'
        },
        {
            field: 'data.nielsenSId',
            displayName: 'SID',
            cellTemplate: 'components/visual/grid/padded-base-tooltip-template.html'
        }
    ];

    this.gridOptions = {
        rowSelection: true,
        enableRowHeaderSelection: false,
        enableSelectAll: false,
        enableColumnResizing: true,
        enablePaginationControls: false,
        enableSorting: false,
        enableColumnMenus: false,
        enableFullRowSelection: true,
        enableHorizontalScrollbar: uiGridConstants.ALWAYS,
        enableVerticalScrollbar: uiGridConstants.ALWAYS,
        rowHeight: 26,
        multiSelect: false,
        columnDefs: columnDefinitions,
        onRegisterApi: (gridApi: JS5Object): void => {
            this.gridApi = gridApi;
            this.gridApi.grid.registerRowsProcessor(this.processGridFilter, 200);
        },
        rowTemplate: 'components/visual/grid/searchview-component-row-template.html',
        data: []
    };
    this.toolbarCheckboxDefs = [
        {
            label: 'Show Hidden',
            onUpdate: (newValue: boolean): void => {
                this.showHidden = newValue;
                getData();
            },
            isChecked: this.showHidden
        }
    ];
    this.$onInit = () => {
        this.loadingIndicator = {
            backdrop: true,
            show: false,
            title: 'Working',
            message: 'Please wait...'
        };
        NavbarUtilService.viewSearchFunction = getData;
        getData();
    };

    const filterGrid = (searchText: string): void => {
        if (!_.isNil(searchText)) {
            this.searchText = searchText.toLowerCase();
            this.gridApi.grid.refresh();
        }
    };


    this.processGridFilter = (rows: JS5Object[]): JS5Object[] => {
        const searchText = $location.search().searchText;
        rows.forEach((row: JS5Object) => {
            _.set(row, 'visible', _.includes(_.toLower(row.entity.name), _.toLower(searchText)));
        });
        return rows;
    };

    this.$onDestroy = (): void => {
        NavbarUtilService.viewSearchFunction = null;
    };
    this.$postLink = () => {
        $timeout(() => {
            PartnerEditService.editorForm = this.editorForm;
        });
    };
}

angular.module('prism-ui.nielsenTemplates').component('nielsenTemplatesSearchView', {
    controller: nielsenTemplatesSearchViewController,
    templateUrl: 'system/partner/editor/components/view/nielsenTemplates/searchView/nielsen-templates-searchview-template.html',
    bindings: {
        partnerObject: '<'
    }
});
